import script from "./ListarTiposPlanos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarTiposPlanos.vue?vue&type=script&setup=true&lang=js"

import "./ListarTiposPlanos.vue?vue&type=style&index=0&id=126943b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126943b7"]])

export default __exports__